import API from './api';

// v=2 — ответ с типом медиа (фото/видео), местами показа (заставка/печать)
// и настройками заставки аппарата. Без него сервер отдаёт старый формат
// только с видео для заставки — так работают киоски прошлых сборок.
export const getAdvertisements = async (deviceToken) => {
    const response = await API.get('/api/v1/advertisements/all', {
        params: { v: 2 },
        headers: {
            'Device-Token': deviceToken,
        },
    });
    return response.data;
};

// placement/completed/watched_ms — для статистики по местам показа. Прерванный
// показ (completed=false) сервер хранит, но не засчитывает.
export const postAdvertisementPlay = async (advertisementId, deviceToken, extra = {}) => {
    const response = await API.post(
        '/api/v1/advertisements/plays/',
        { advertisement_id: advertisementId, ...extra },
        {
            headers: {
                'Device-Token': deviceToken,
            },
        }
    );
    return response.data;
};
